import script from "./whDOnceImg3_t2A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg3_t2A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg3_t2A.vue?vue&type=style&index=0&id=a3facebc&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3facebc"]])

export default __exports__